/* @flow */

import * as React from 'react';

import {Stack} from 'shells/layout';
import {Body} from 'shells/typography';
import {SparkleOpenIcon} from 'shells/icon';
import {colors} from 'shells/colors';

export function SuggestedReplyLabel() {
    return (
        <Stack spacing={4} isHorizontal={true}>
            <SparkleOpenIcon color={colors.aiBlue} size={13} />
            <Body size='small' color='navy-dk' isBold={true}>
                Start a reply with AI
            </Body>
        </Stack>
    );
}
